import React from 'react';
import image1 from '../Images/check_box.png'
// import image2 from '../Images/library_add.png'
import image3 from '../Images/add_box.png'
import comment from '../Images/comment.svg'
import call from '../Images/call.svg'
import conv from '../Images/conversion.svg'
import npc from '../Images/NPC.svg'
import player from '../Images/Player.svg'
import branch from '../Images/Branch.svg'
import random from '../Images/tenancy.svg'
import saveAs from '../Images/saveAs.svg'



const height = 2
const Sidebar = () => {

    const onDragStart = (event, nodeType) => {
        event.dataTransfer.setData('application/reactflow', nodeType);
        event.dataTransfer.effectAllowed = 'move';
    };

    return (
        // <div style={{position:"fixed",zIndex:"344", bottom:"14px", right:"0", left:"0", display:"flex",
        // justifyContent:'center'
        // }}>
        <div style={{
            position: "fixed", left: "-4px", top: "20%", bottom: "20%", zIndex: "500",
            display: "flex", flexDirection: 'column', padding: "20px", justifyContent:"center",

        }}>


            <aside className="DND" style={{zIndex: '500'}}>
                <div className="dndnode input" onDragStart={(event) => onDragStart(event, 'Main')} draggable>
                    <img className="dndImg" src={image3} alt=""/>
                </div>
            </aside>

            <aside className="DND" style={{zIndex: '500'}}>
            <div className="dndnode output" onDragStart={(event) => onDragStart(event, 'Npc')} draggable>
                <img className="dndImg" src={npc} alt=""/>
            </div>

            <div className="dndnode output" onDragStart={(event) => onDragStart(event, 'Player')} draggable>
                <img className="dndImg" src={player} alt=""/>
            </div>
            </aside>


            <aside className="DND" style={{zIndex: '500'}}>
                <div className="dndnode output" onDragStart={(event) => onDragStart(event, 'If')} draggable>
                    <img className="dndImg" src={conv} alt=""/>
                </div>

                <div className="dndnode output" onDragStart={(event) => onDragStart(event, 'Branch')} draggable>
                    <img className="dndImg" src={branch} alt=""/>
                </div>

                <div className="dndnode output" onDragStart={(event) => onDragStart(event, 'Random')} draggable>
                    <img className="dndImg" src={random} alt=""/>
                </div>
                {/*<div className="dndnode output" onDragStart={(event) => onDragStart(event, 'Data')} draggable>*/}
                {/*    <img  className="dndImg"  src= {data} alt=""/>*/}
                {/*</div>*/}
            </aside>


            <aside className="DND" style={{zIndex: '500'}}>
                <div className="dndnode output" onDragStart={(event) => onDragStart(event, 'Commands')} draggable>
                    <img className="dndImg" src={call} alt=""/>
                </div>

                <div className="dndnode" onDragStart={(event) => onDragStart(event, 'Data')} draggable>
                    <img className="dndImg" src={saveAs} alt=""/>
                </div>
            </aside>


            <aside className="DND" style={{zIndex: '500'}}>
                <div className="dndnode" onDragStart={(event) => onDragStart(event, 'Comment')} draggable>
                    <img className="dndImg" src={comment} alt=""/>
                </div>
            </aside>

        </div>

    );
};

export default Sidebar;